import React, {useState} from 'react'
import ClickOutsideCustom from '@components/ClickOutside'
import ClientSuspense from '@components/ClientSuspense'
import Pill from '@components/V3/Pill'
import useUserId from '@hooks/useUserId'
import {useTranslation} from 'next-i18next'

import useUserInfo from '../hooks/useUserInfo.main'

import LoginButton from './LoginButton'
import UserMenuSkeleton from './Skeleton'
import UserMenuLinks from './UserMenuLinks'

type ComponentProps = {
  open?: boolean
  closeMenu?: any
  toggleOpen?: any
  onlyOptions?: boolean
}

const translatePrefix = 'layout.layouts.default.navbar.menu'

const UserMenuInner = ({open: initialOpen, toggleOpen, onlyOptions}: ComponentProps) => {
  const {t} = useTranslation('website')
  const [open, setOpen] = useState(initialOpen)
  const userId = useUserId()
  const {me} = useUserInfo()

  const toggleMenu = () => {
    setOpen(!open)
    if (toggleOpen) {
      toggleOpen()
    }
  }

  const renderIcon = () => {
    if (me) {
      return (
        <div
          className="flex items-center justify-center cursor-pointer font-bold text-base px-2 py-1 mx-auto"
          onClick={toggleMenu}>
          {me.name === 'Sin nombre'
            ? t(`${translatePrefix}.labelMyAccount`)
            : me.name.charAt(0) + me?.lastName?.charAt(0)}{' '}
        </div>
      )
    } else if (!userId) {
      return <LoginButton />
    } else {
      return (
        <div
          className={
            'flex items-center justify-between cursor-pointer font-bold text-base text-inherit px-2 py-1 min-w-[100px]'
          }>
          {t(`${translatePrefix}.labelLoading`)}
        </div>
      )
    }
  }

  if (onlyOptions) return <UserMenuLinks open={open} />

  return (
    <ClickOutsideCustom onClickOutside={open ? toggleMenu : () => null}>
      <Pill showCaret={false} className="h-12 min-w-12 w-fit !px-0">
        <div className="font-normal relative">
          {renderIcon()}
          <UserMenuLinks open={open} />
        </div>
      </Pill>
    </ClickOutsideCustom>
  )
}

export default function UserMenu(props: ComponentProps) {
  return (
    <ClientSuspense fallback={<UserMenuSkeleton />}>
      <UserMenuInner {...props} />
    </ClientSuspense>
  )
}
